import { createReducer, on } from '@ngrx/store';
import { EntryCyclesView } from '../../../_generated';
import { EntryCyclesActions } from '../../actionstypes/entry-cycles/entry-cycles.actiontype';

const initialState: EntryCyclesView[] = [];

export const entryCyclesReducer = createReducer(
  initialState,
  on(EntryCyclesActions.get, (state, { entryCycles }) => entryCycles),
  on(EntryCyclesActions.reset, () => []),
);
